import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import formattingRulesParameters from '@atlassian/jira-relay/src/__generated__/FormatRulesQuery$parameters';
import parameters from '@atlassian/jira-relay/src/__generated__/JiraBusinessListAppQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const FORMAT_RULES_FIRST = 20;

export const listEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-business-list-entrypoint" */ './src/JiraBusinessListApp.tsx'
			),
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				listQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
				formattingRulesQuery: {
					parameters: formattingRulesParameters,
					variables: {
						projectKey,
						cloudId,
						first: FORMAT_RULES_FIRST,
					},
					options: {
						fetchPolicy: 'network-only' as const,
					},
				},
			},
		};
	},
});
